/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ApprovalRequestChangelogRequest} from '../models/ApprovalRequestChangelogRequest';
import type {ApprovalRequestChangelogResponse} from '../models/ApprovalRequestChangelogResponse';
import type {Error} from '../models/Error';

export interface GetApprovalRequestChangelog$Request {
    approvalRequestChangelogRequest: ApprovalRequestChangelogRequest;
}

export interface GetApprovalRequestChangelog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getApprovalRequestChangelogRequest = createAction<PayloadData<void, GetApprovalRequestChangelog$Request>>('REQUEST_CHANGELOG__GET_APPROVAL_REQUEST_CHANGELOG__REQUEST');
export const getApprovalRequestChangelogSuccess = createAction<PayloadData<ApprovalRequestChangelogResponse, GetApprovalRequestChangelog$Request>>('REQUEST_CHANGELOG__GET_APPROVAL_REQUEST_CHANGELOG__SUCCESS');
export const getApprovalRequestChangelogFailure = createAction<PayloadData<Error, GetApprovalRequestChangelog$Request, true>>('REQUEST_CHANGELOG__GET_APPROVAL_REQUEST_CHANGELOG__FAILURE');

export const getApprovalRequestChangelogActions = [
    getApprovalRequestChangelogRequest,
    getApprovalRequestChangelogSuccess,
    getApprovalRequestChangelogFailure
] as const;

/**
 * Get approval change info for a list of request IDs.
 * @param {ApprovalRequestChangelogRequest} meta.approvalRequestChangelogRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getApprovalRequestChangelog = (meta: GetApprovalRequestChangelog$Request, config?: GetApprovalRequestChangelog$Config) => {
    return {
        CALL_API: {
            types: getApprovalRequestChangelogActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/approval/requests/changelog`,
            TRANSPORT_REQUEST_BODY: meta.approvalRequestChangelogRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

